<template>
  <transition name="show">
    <div class="searchmessage" v-show="petlist">
      <header-top :onshow="true" @backto="backto" :mine='true'></header-top>
      <div class="main" ref="wrapper">
        <div style="height:600px;">
          <div class="title" v-if="false">
            <p>{{$t('searchmessage.title')}}</p>
            <span>{{title}}</span>
          </div>
          <div class="describe">
            <p>{{$t('searchmessage.describe')}}</p>
            <span>{{textarea}}</span>
          </div>
          <div class="time">
            <p>{{$t('releaseSearch.losttime')}}</p>
            <span>{{time}}</span>
          </div>
          <div class="place">
            <p>{{$t('petDetails.lost')}}</p>
            <span>{{adress}}</span>
          </div>
          <div class="pet">
            <p>{{$t('changefindpetinfo.findPet')}}</p>
            <img :src="petimg">
          </div>
          <div class="petphoto">
            <p>{{$t('searchmessage.petphone')}}</p>
            <div class="photo">
              <img :src="avatar" v-if="avatar">
              <img :src="avatar1" v-if="avatar1">
              <img :src="avatar2" v-if="avatar2">
            </div>
          </div>
          <div class="type">
            <p>{{$t('changefindpetinfo.findStatus')}}</p>
            <span>{{type}}</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import headerTop from "../../components/header";
import IScroll from "iscroll/build/iscroll-probe";
import { getpet } from "../../ClientServerApi/index.js";
import Qs from "qs";
export default {
  name: "searchmessage",
  props: ["petlist"],
  data() {
    return {
      showflag: false,
      title: "",
      textarea: "",
      time: "",
      adress: "",
      petimg: "",
      avatar: "",
      avatar1: "",
      avatar2: "",
      type: ""
    };
  },
  components: {
    headerTop
  },
  mounted() {
    this.$nextTick(() => {
      this.Scroll = new IScroll(this.$refs.wrapper, {
        click: true
      });
    });
    let params = Qs.stringify({ petId: this.petlist.petId });
    getpet(params)
      .then(res => {
        for (var i = 0; i < res.data.data.length; i++) {
          if (this.petlist.petId == res.data.data[i].petId) {
            this.petimg = res.data.data[i].portrait;
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
    this.title = this.petlist.title;
    this.textarea = this.petlist.content;
    this.time = this.petlist.loseTime.slice(0, 10);
    this.adress = this.petlist.lostPlace;
    if (JSON.parse(this.petlist.featurePhoto)[0]) {
      this.avatar = JSON.parse(this.petlist.featurePhoto)[0];
    }
    if (JSON.parse(this.petlist.featurePhoto)[1]) {
      this.avatar1 = JSON.parse(this.petlist.featurePhoto)[1];
    }
    if (JSON.parse(this.petlist.featurePhoto)[2]) {
      this.avatar2 = JSON.parse(this.petlist.featurePhoto)[2];
    }
    if (this.petlist.isOpen == 0) {
      this.type = this.$t('mysearch.closed');
    }
    if (this.petlist.isOpen == 1) {
      this.type = this.$t('mysearch.finding');
    }
    if (this.petlist.isOpen == 2) {
      this.type = this.$t('mysearch.finded');
    }
  },
  methods: {
    backto() {
      this.$emit("show");
    }
  }
};
</script>
<style scoped>
.describe span {
  display: block;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
.searchmessage {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0px;
  width: 100%;
  z-index: 30;
  background-color: #fff;
  transition: all 0.2s linear;
}
.searchmessage.show-enter,
.searchmessage.show-leave-to {
  transform: translateX(100%);
}
.main {
  touch-action: none;
  position: absolute;
  top: 55px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
}
.main p {
  font-size: 0.9rem;
  color: rgb(18, 87, 157);
  margin-left: 20px;
  margin-top: 10px;
}
.main span {
  font-size: 0.75rem;
  margin-top: 5px;
  margin-left: 20px;
  display: inline-block;
}
.pet img {
  margin-top: 10px;
  margin-left: 20px;
  width: 60px;
  height: 60px;
}
.photo img {
  margin-top: 10px;
  margin-left: 20px;
  width: 60px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/m_page/myAccount/searchmessage.vue